module.exports = __webpack_public_path__ + "img/iconAdd.fb4b69f7.png";